import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '4fr 24fr 27fr 8fr 24fr 1fr',
    gap: 12,
    alignItems: 'center',
    marginBottom: 12,
    [theme.breakpoints.down('sm')]: {
      gap: 6
    }
  },
  counter: {
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    width: 40,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white'
  },
  RestrictionsContainer: {
    display: 'flex',
    '&>div': {
      marginRight: 12
    }
  },
  counterSkeleton: {
    width: 40,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  weekdays: {
    display: 'flex'
  },
  hidden: {
    opacity: 0
  }
}))

export default useStyles
